import React from "react";
import { Switch, Route } from "react-router-dom";
import {
  default as GeneralInformationIndex
} from "../../../pages/coordinator/odes/show/general-information";
import {
  default as TeamIndex
} from "../../../pages/coordinator/odes/show/team";
import {
  default as MyDocumentsIndex
} from "../../../pages/admin/odes/show/my-documents";
import {
  default as PitchIndex
} from "../../../pages/coordinator/odes/show/pitch";
import { OdesIndex } from "../../../pages/coordinator/odes";
import {
  default as BatchesIndex
} from "../../../pages/coordinator/odes/show/batches";
import {
  default as TasksIndex
} from "../../../pages/coordinator/odes/show/tasks";
import { OnePagerIndex } from "../../../pages/coordinator/odes/show/one-pager";
import MetricsIndex from "../../../pages/coordinator/odes/show/metrics";

export const CoordinatorODEsRoutes = <Switch>
  <Route
    exact
    path="/v2/coordinator/odes"
    component={OdesIndex} />
  <Route
    path="/v2/coordinator/odes/:id/one-pager"
    component={OnePagerIndex} />
  <Route
    path="/v2/coordinator/odes/:id/general-information"
    component={GeneralInformationIndex} />
  <Route
    path="/v2/coordinator/odes/:id/my-documents"
    component={MyDocumentsIndex} />
  <Route
    path="/v2/coordinator/odes/:id/team"
    component={TeamIndex} />
  <Route
    path="/v2/coordinator/odes/:id/pitch"
    component={PitchIndex} />
  <Route
    path="/v2/coordinator/odes/:id/batches"
    component={BatchesIndex} />
  <Route
    path="/v2/coordinator/odes/:id/metrics"
    component={MetricsIndex} />
</Switch>;
